import type { ParameterData } from '@/core/types/library.type'
import { coerceParameterValue } from '@/core/utils/coerceParameterValue'

interface CoerceParametersFromMapParams {
  parameters: ParameterData[]
  valueMap: Record<string, string | number>
}

export const coerceParametersFromMap = ({ parameters, valueMap }: CoerceParametersFromMapParams): unknown[] =>
  parameters.map((parameter) =>
    coerceParameterValue(valueMap[parameter.name] ?? '', parameter.typeUsage ?? parameter.primitiveType)
  )
